import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import FooterPage from "../components/Footer";

export default function AGBs() {
  const { t } = useTranslation();

  const sections = [
    { key: "scope" },
    { key: "services" },
    { key: "account" },
    { key: "payment" },
    { key: "dataPrivacy" },
    { key: "liability" },
    { key: "termination" },
    { key: "changes" },
    { key: "law" },
  ];

  return (
    <>
    <section className="relative flex items-center justify-center w-full min-h-screen overflow-hidden bg-white">
      {/* Background Image Scale Animation */}
      {/* <motion.img
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5 }}
        
      /> */}

      {/* <div className="absolute inset-0 bg-gray-50 opacity-30" /> */}

      {/* Navbar Animation */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="absolute top-0 left-0 z-50 w-full"
      >
        <Navbar />
      </motion.div>
    <div className="max-w-2xl mx-auto px-6 py-12 mt-[104px]">
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        {t("agbs.title")}
      </h1>
      <p className="text-sm text-gray-500 mb-10">
        {t("agbs.lastUpdated")}: {t("agbs.date")}
      </p>

      <p className="text-gray-700 leading-relaxed mb-10">
        {t("agbs.intro")}
      </p>

      {sections.map((section, index) => (
        <section key={section.key} className="mb-8">
          <h2 className="text-base font-semibold text-gray-900 mb-3">
            §{index + 1} {t(`agbs.sections.${section.key}.title`)}
          </h2>
          <p className="text-gray-700 leading-relaxed text-sm">
            {t(`agbs.sections.${section.key}.text`)}
          </p>
        </section>
      ))}

      <div className="border-t pt-8 mt-8">
        <p className="text-sm text-gray-500">
          {t("agbs.contact")}:{" "}
          <a href="mailto:info@swisstaxfile.ch" className="text-blue-600 hover:underline">
            info@swisstaxfile.ch
          </a>
        </p>
      </div>
    </div>
    
    </section>
    <FooterPage />
    </>
  );
}